import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ImageRequestSearch } from '../../../../models/api-dam/image/image-request.model';
import { ImageService } from '../../../../services/api-dam/image/image.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { ImageResponse } from '../../../../models/api-dam/image/image-response.model';
import { FloatingItem } from '../../../../components/ui/floatingbar/floatingbar-item';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ActionConfirmComponent } from '../../../../components/ui/actionconfirm/actionconfirm.component';
import { ActionConfirmModel } from '../../../../models/action-confirm.model';
import { ImmaginiCreateComponent } from './immagini-create/immagini-create.component';
import { ImmaginiEditComponent } from './immagini-edit/immagini-edit.component';
import { ImmaginiCropComponent } from './immagini-crop/immagini-crop.component';
import { DIALOG_LARGE_CONFIG, DIALOG_MEDIUM_CONFIG } from '../../../../utils/config/modal-settings';
import { LOADINGIMAGE } from '../../../../utils/config/image-settings';
import { FALSE, TRUE } from '../../../../utils/config/const';
import { UtilsService } from '../../../../services/utils-folder/utils.service';

@Component({
  selector: 'app-immagini',
  templateUrl: './immagini.component.html',
  styleUrls : ['./immagini.component.scss']
})
export class ImmaginiComponent implements OnInit {

  private DIMPAGE_default:number = 40;
  private NUMEROPAGINA_default:number = 0;
  public imagesList :any = [];
  public imageListFirstsearch:boolean = false;
  public imagesMapList :any = {};
  public dimPagina:number = this.DIMPAGE_default;
  public numeroPagina:number = this.NUMEROPAGINA_default;
  searchFilterForm: FormGroup;
  busyGettingData: boolean = false;
  previousScroll = 0;



  /**
   * Configura i button della floatingbar
   */
  public menuItems:FloatingItem[] = [
    {
      title:'',
      icon:'fas fa-upload',
      choice:'CREATE'
    }
  ];

  constructor(
    private imageService:ImageService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private utilsService: UtilsService
  ) { 
    this.searchFilterForm = this.fb.group({
      searchFilterField: ''
     });
    
  }

  ngOnInit() { 
    this.spinner.show();
    this.search();
  }

  /**
   * Click sulla lente per la ricerca
   */
  clickSearch(){
    this.resetListImage();
    this.search();
  }

  /**
   * Prende i filtri
   * @returns 
   */
  getFilter(){
    let imageRequestSearch = new ImageRequestSearch();
    imageRequestSearch.name =  this.searchFilterForm.controls['searchFilterField'].value;
    imageRequestSearch.pageNumber = this.numeroPagina;
    imageRequestSearch.pageSize = this.dimPagina;
    imageRequestSearch.sortBy = "createdAt:desc";
    return imageRequestSearch;
  }

  /**
   * Ricerca generica
   */
  search(){
    this.imageListFirstsearch = false;
    let imageRequestSearch = this.getFilter();
    this.imageService.search(imageRequestSearch).subscribe(
      (response) => {
        this.spinner.hide();
        if(response != null && typeof response != typeof undefined){
          if (response.data.length > 0) {
            this.imageListFirstsearch = true;
            this.setListImage(response);
            this.busyGettingData = false
          }
        }
      },
      (error: HttpErrorResponse)=>{
        this.spinner.hide();
        this.imageListFirstsearch = true;
        console.log(error);
        this.busyGettingData = false
      }
    );
  }

  /**
   * Setta le informazioni della response 
   * */ 
   setListImage(response){
    if(response != null && typeof response != typeof undefined){
      if(response.hasOwnProperty("data")){
        let data = response.data
        for(let i=0;i< data.length;i++){
          this.insertImage(data[i],i);
        }
      } 
    }
  }


  insertImage(imageObj,pos){
    let idImage = imageObj.id;
    this.imagesMapList[idImage]=pos;
    if( imageObj.published === FALSE){
      imageObj.url = LOADINGIMAGE;
    }
    this.imagesList.push(imageObj);
    if( imageObj.published === FALSE){
      this.downloadImage(idImage);
    }
  }

  /**
   * Reset dei filtri di ricerca
   */
  resetListImage(){
    this.imagesList = [];
    this.imagesMapList = {};
    this.dimPagina = this.DIMPAGE_default;
    this.numeroPagina = this.NUMEROPAGINA_default;
  }

  /**
   * Cancella immagine
   * @param idImage 
   */
  deleteImage(idImage){
    this.imageService.delete(idImage)
      .subscribe(
        (response:any) => {
          
          //Aggiorna lista immagini
          this.imagesList.splice(this.imagesMapList[idImage],1);
          //Togli spinner
          this.spinner.hide();
          //Feedback all'utente
          this.toastr.success('Immagine cancellata con successo', 'Cancella immagine');
        },
        (error:HttpErrorResponse) => {
          console.log(error);
          this.spinner.hide();
          this.toastr.error('Si è verificato un errore durante la cancellazione dell\'immagine' , 'Cancella immagine fallita', {
            timeOut: 5000
          });
        }
      );
  }


  


  /**
   * Carica immagine non pubblica
   * @param idImage 
   */
  downloadImage(idImage){
    this.imageService.download(idImage).subscribe(
      (response) => {
        this.imagesList[this.imagesMapList[idImage]].url = this.utilsService.getSecurityTrustURL(response);
      },
      (error: HttpErrorResponse)=>{
        this.imagesList[this.imagesMapList[idImage]].url="/assets/images/no-image-icon.png";
      }
    );
  }



  /**
   * Azione sull'immagine - Pubblica/Depubblica
   * @param imgObj 
   * @param publish 
   */
  clickButtonPublishImage(imgObj,publish){
    this.imageService.publish(imgObj.id,publish).subscribe(
      (response:ImageResponse) => {
        if(response != null && typeof response != typeof undefined){
          imgObj.published = response.published;
          imgObj = response; 
          if(publish){
            this.toastr.success('Immagine pubblicata con successo' , 'Pubblica immagine', {
              timeOut: 5000
            });
          }else{
            this.toastr.success('Immagine depubblicata con successo' , 'Depubblica immagine', {
              timeOut: 5000
            });
          }
        } 
      },
      (error) => {
        if(publish){
          this.toastr.error('Si è verificato un errore durante la pubblicazione dell\'immagine' , 'Pubblica immagine fallita', {
            timeOut: 5000
          });
        }else{
          this.toastr.error('Si è verificato un errore durante la depubblicazione dell\'immagine' , 'Depubblica immagine fallita', {
            timeOut: 5000
          });
        }
      }
    );
  }

  

  /**
   * Azione sull'immagine - Modifica
   * @param idImage 
   */
  clickButtonUpdateImage(idImage){
      //Apertura modale di modifica 
      const modalRef = this.modalService.open(ImmaginiEditComponent, DIALOG_LARGE_CONFIG);
      modalRef.componentInstance.idImage = idImage;
      modalRef.result.then((result:any) => {
        if (result) {
          if(result != 'CLOSE'){
            
            let index = this.imagesMapList[result.id];
            this.imagesList[index].name = result.name;
            this.imagesList[index].published = result.published;
          }
        }
      }, (error) => {
          console.log(error);
      });
  }

  /**
   * Azione sull'immagine - Cancella
   * @param idImage 
   */
  clickButtonDeleteImage(idImage){
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare l'immagine?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
        if (result) {
          if(result.confirm === TRUE){
            this.deleteImage(idImage);
          }
        }
    }, (error) => {
        console.log(error);
    });  
  }




  /**
   * Gestione degli eventi della floatingBar
   * @param $event  
   */
  choiceButtonResponse($event){
    if($event == "CREATE"){
      //Apre modale di create
      const modalRef = this.modalService.open(ImmaginiCreateComponent, DIALOG_LARGE_CONFIG);
      modalRef.result.then(result => {
        if (result) {
          if(result != "CLOSE"){
            let id = result.id;
            let pos = this.imagesList.length;
            this.imageService.getEntity(id).subscribe(
              (response)=>{
                this.insertImage(response,pos);
              },
              (error)=>{
                this.toastr.error('Si è verificato un errore durante il caricamento dell\'immagine' , 'Caricamento immagine fallita', {
                  timeOut: 5000
                });
              }
            );
          }
          
        }
      }, (error) => {
          console.log(error);
      });
    }
  }

  clickButtonCropImage(idImage){
    //Apertura modale cropper
    const modalRef = this.modalService.open(ImmaginiCropComponent, { size: 'xl' , centered: true });
    modalRef.componentInstance.idImage = idImage;
    modalRef.result.then((result:any) => {
      if (result) {
        if(result != "CLOSE"){
          let pos = this.imagesList.length;
          this.insertImage(result,pos);
        }
      }
    }, (error) => {
        console.log(error);
    });
  }

  onScrollDown() {
      let currentScroll = window.pageYOffset;
      if (currentScroll > this.previousScroll) {
        this.previousScroll = currentScroll;
        if (this.busyGettingData) {
          return
        } else {
          this.busyGettingData = true
          this.numeroPagina++;
          this.search();
        }

    } else if (currentScroll < this.previousScroll) {
        this.previousScroll = currentScroll;
    }
  }

 

}
